import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconShoppingCartRg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37}
    height={32}
    fill="none"
    viewBox="0 0 37 32"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-shopping-cart-rg_svg__a)"
      d="M28.938 26c1.687 0 2.937 1.375 2.937 3 0 1.688-1.375 3-2.938 3C27.313 32 26 30.687 26 29c0-1.625 1.25-3 2.938-3Zm-18 0c1.687 0 2.937 1.375 2.937 3 0 1.688-1.375 3-2.938 3C9.313 32 8 30.687 8 29c0-1.625 1.25-3 2.938-3ZM35.561 2.812c.376.5.5 1.188.313 1.813l-3.438 11.938c-.25.875-1 1.437-1.874 1.437H10.625l.563 3H30.5c.813 0 1.5.688 1.5 1.563 0 .812-.688 1.437-1.5 1.437H10c-.75 0-1.375-.5-1.563-1.188L4.688 3h-3.25C.625 3 0 2.25 0 1.5 0 .687.625 0 1.438 0H6c.688 0 1.313.563 1.438 1.25l.125.75h26.375c.687 0 1.25.313 1.624.813Z"
    />
    <defs>
      <linearGradient
        id="icon-shopping-cart-rg_svg__a"
        x1={36}
        x2={4.221}
        y1={0}
        y2={35.752}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconShoppingCartRg;
